import clsx from 'clsx';
import { EmailsSent, EmailsSentLabelMap } from '@airreading/common/data';
import { Badge } from '@/components/ui/badge.js';

interface EmailsSentBadgeProps {
  emailsSent: EmailsSent;
}

const EmailsSentColorMap: Record<EmailsSent, string> = {
  [EmailsSent.first_warning]: 'bg-[#DBEAFE] hover:bg-[#DBEAFE] text-[#2563EB]',
  [EmailsSent.maximum_limit]: 'bg-[#F3E8FF] hover:bg-[#F3E8FF] text-[#9333EA]',
  [EmailsSent.reassignment]: 'bg-[#FFE4E6] hover:bg-[#FFE4E6] text-[#E11D48]',
  [EmailsSent.late_entry_warning]: 'bg-[#FFEDD5] hover:bg-[#FFEDD5] text-[#C2410C]',
  [EmailsSent.late_entry_final_warning]: 'bg-[#FEE2E2] hover:bg-[#FEE2E2] text-[#B91C1C]',
  [EmailsSent.early_exit_warning]: 'bg-[#FFEDD5] hover:bg-[#FFEDD5] text-[#C2410C]',
  [EmailsSent.early_exit_final_warning]: 'bg-[#FEE2E2] hover:bg-[#FEE2E2] text-[#B91C1C]',
  [EmailsSent.substitute_1_remaining]: 'bg-[#DCFCE7] hover:bg-[#DCFCE7] text-[#166534]',
  [EmailsSent.substitute_at_allowance]: 'bg-[#FEF3C7] hover:bg-[#FEF3C7] text-[#854D0E]',
  [EmailsSent.substitute_1_over]: 'bg-[#FFEDD5] hover:bg-[#FFEDD5] text-[#9A3412]',
};

export const EmailsSentBadge = ({ emailsSent }: EmailsSentBadgeProps) => {
  return (
    <Badge
      className={clsx(
        'p-1 rounded-[6px] text-[14px] text-center font-bold whitespace-nowrap',
        EmailsSentColorMap[emailsSent],
      )}
    >
      {EmailsSentLabelMap[emailsSent]}
    </Badge>
  );
};
